export const faqBookeeping = [
  {
    title: "bookeeping_faq_title_one",
    description: "bookeeping_faq_desc_one"
  },
  {
    title: "bookeeping_faq_title_two",
    description: "bookeeping_faq_desc_two"
  },
  {
    title: "bookeeping_faq_title_three",
    description: "bookeeping_faq_desc_three"
  },
  {
    title: "bookeeping_faq_title_four",
    description: "bookeeping_faq_desc_four"
  },
  {
    title: "bookeeping_faq_title_five",
    description: "bookeeping_faq_desc_five"
  },
  {
    title: "bookeeping_faq_title_six",
    description: "bookeeping_faq_desc_six"
  },
]